/**
 * General class to interact with a questionnaire model
 *
 * @param {object} questionnaire - received from /admin/questionnaires/:id
 * @param {service} service - received from /admin/categories/:id
 */
class Questionnaire {
  constructor(questionnaire, service = {}) {
    Object.assign(this, questionnaire, {
      service
    });
  }
  /**
   * Can we edit the questionnaire
   */


  get editable() {
    return this.drafting || this.testing;
  }

  get drafting() {
    return this.phase === 'draft';
  }

  get testing() {
    return this.phase === 'test';
  }

  get published() {
    return this.phase === 'published';
  }
  /**
   * Determines if this questionnaire is the current staging questionnaire for the associated service
   * @returns {boolean} - t/f
   */


  isStaged() {
    return this.id === +this.service.staged_questionnaire_id; // the "+" coerces strings to numbers. "11" becomes 11
  }

  isProductLive() {
    return this.products.length > 0;
  }

  /**
   * Determines if this questionnaire is the current live questionnaire for the associated service
   * @returns {boolean} - t/f
   */


  isLive() {
    return this.id === +this.service.questionnaire_id; // the "+" coerces strings to numbers. "11" becomes 11
  }
  /**
   * Determines if the questionnaire is able to become the live questionnaire displayed to patients
   * @returns {boolean} - t/f
   */


  canGoLive() {
    return !this.isLive() && this.published;
  }
  /**
   * Determines if the questionnaire is able to become the staged questionnaire displayed to QA
   * @returns {boolean} - t/f
   */


  canGoStaged() {
    return !this.isStaged() && (this.testing || this.published);
  }

}

window.Questionnaire = Questionnaire;
